import styled from "@emotion/styled";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

export const BreadcrumbsContainer = styled.div`
  ${Styles.BreakpointsUtils.mobileOnly(`
    display: none;
  `)};

  position: absolute;
  bottom: auto;
  left: 0px;
  z-index: 33;
  width: 100%;
  display: flex;
  justify-content: center;

  ol {
    list-style-type: none;
    padding: 2px 0;
    margin: 0;

    &.margin-extra-small {
      left: 0;
      position: absolute;
      padding: 10px 10%;
      margin: 0px 0px 0px 4px;
    }

    &.margin-notifiche {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: calc(1280px * 0.9);
      padding-left: 4px;
      margin-left: 3%;

      ${Styles.BreakpointsUtils.tabletOnly(`
        width: 80%;
      `)};
    }

    &.margin-normal {
      ${Styles.BreakpointsUtils.desktopOnly(`
        width: 1052px;
      `)};

      ${Styles.BreakpointsUtils.tabletOnly(`
        margin-left: 5%;
        width: 100%;
      `)};
    }

    &.margin-small {
      ${Styles.BreakpointsUtils.desktopOnly(`
        width: 1158px;
      `)};
      ${Styles.BreakpointsUtils.tabletOnly(`
        margin-left: 4.9%;
        width: 100%;
      `)};
    }

    a {
      transition: all 0.25s ease-out 0s;
      border-bottom: 1px solid transparent;
      text-decoration: none;
      color: #fff;
      &:hover {
        border-bottom: 1px solid white;
      }
    }

    .breadcrumb-item {
      color: #fff;
      display: inline;
      font-size: 13px;
      font-family: "Unipol";

      &:before {
        display: none;
      }

      &:after {
        padding: 0 10px;
        content: "> ";
      }

      &.current:after {
        content: "";
      }

      &.current {
        font-family: "Unipol Bold";
      }
    }
  }
`;
